export default __webpack_public_path__ + "static/color-analysis-result-autumn-a64ba0c5b49eb4eb8bf2dc3d33804a73.jpg";